import React, {useEffect, useState} from 'react';
import {Award, CheckCircle, Clock, OctagonX} from 'lucide-react';
import {useApiCreateCertificationPDF, useApiSearchStudentCertifications} from "@/api/certification";
import StudentLayout from "@/components/layout/student/studentLayout";
import {URLS} from "@/lib/urls";
import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";
import RenderIf from "@/components/render-if";
import CertificateCard from "@/pages/student/certifications/_section/CertificationCardSection";


export default function StudentCertificationListPage() {
    const [certificates, setCertificates] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);


    const {mutate: pdfRequest, isPending: isPendingPDF} = useApiCreateCertificationPDF();
    const {data, isPending, refetch} = useApiSearchStudentCertifications({enable: true});

    function handlePDFRequest(id) {
        pdfRequest({id: id}, {
            onSuccess: (data) => {
                ApiHandleSuccessMessage(data)
            },
            onError: (error) => {
                ApiHandleErrorMessage(error)
            }
        })
    }


    useEffect(() => {
        if (data?.data?.data?.length > 0) {
            setCertificates(data?.data?.data);
        }
    }, [data]);


    const getPdfStatusBadge = (status) => {
        switch (status) {
            case 'done':
                return (
                    <span
                        className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
            <CheckCircle className="w-3.5 h-3.5"/>
            آماده دانلود
          </span>
                );
            case 'queue':
                return (
                    <span
                        className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium bg-amber-100 text-amber-800">
            <Clock className="w-3.5 h-3.5"/>
            در حال آماده‌سازی
          </span>
                );

            case 'failed':
                return (
                    <span
                        className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800">
            <OctagonX className="w-3.5 h-3.5"/>
            خطا در هنگام تولید تصویر
          </span>
                );

            default:
                return null;
        }
    };


    return (
        <StudentLayout pageTitle={'گواهی‌نامه‌ها'} backTo={URLS.student.dashboard}
                       pageLoading={isPending}
        >
            <RenderIf condition={certificates.length === 0}>
                <div className=" rounded-2xl shadow-sm border dark:border-gray-600 border-slate-200 p-12 text-center">
                    <Award className="w-16 h-16 text-slate-300 mx-auto mb-4"/>
                    <h3 className="text-xl font-semibold   mb-2">
                        هنوز گواهینامه‌ای دریافت نکرده‌اید
                    </h3>
                    <p className=" ">
                        با تکمیل دوره‌های آموزشی، گواهینامه‌های خود را دریافت کنید
                    </p>
                </div>
            </RenderIf>

            <RenderIf condition={certificates.length > 0}>
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
                    {certificates.map((cert) => (
                        <CertificateCard certificate={cert} refetch={refetch}/>
                    ))}
                </div>

            </RenderIf>

        </StudentLayout>
    );
}
